import React from 'react';
import _ from 'lodash';
import Button from '@material-ui/core/Link';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { useTranslation } from 'react-i18next';
import MoreIcon from '@material-ui/icons/ExpandMore';
import { useDevices, useFields } from 'hooks';
import PropTypes from 'prop-types';
import { DashboardHelpers } from 'utils';

const ProbePicker = ({ setSelectedDeviceOverride, selectedDeviceOverride }) => {
  const { devices, selectedDevice, setSelectedDevice } = useDevices();
  const { selectedField } = useFields();
  const { t } = useTranslation();
  const activeFieldDevices = _.filter(devices, { field_id: selectedField?.id });
  const setDevice = setSelectedDeviceOverride ? setSelectedDeviceOverride : setSelectedDevice;
  const device = selectedDeviceOverride ? selectedDeviceOverride : selectedDevice;
  const getProbeItems = (popupState) => {
    const deviceItems = [
      <MenuItem
        key="none"
        onClick={(e) => {
          popupState.close(e);
          setDevice(undefined);
        }}
      >
        {t('field_average')}
      </MenuItem>,
    ];
    _.forEach(activeFieldDevices, (probe) => {
      deviceItems.push(
        <MenuItem
          key={probe.hw_address}
          onClick={(e) => {
            popupState.close(e);
            setDevice(probe);
          }}
        >
          {DashboardHelpers.trimHWAddress(probe.hw_address)}
        </MenuItem>
      );
    });
    return deviceItems;
  };
  let buttonText = t('field_average');
  if (device) {
    const d = _.find(activeFieldDevices, { hw_address: device.hw_address });
    if (d) {
      buttonText = DashboardHelpers.trimHWAddress(d.hw_address);
    }
  }
  return (
    <PopupState variant="popover" popupId="device-popup-menu">
      {(popupState) => (
        <>
          <Button {...bindTrigger(popupState)}>
            <div style={{ display: 'flex' }}>
              <Typography variant="subtitle1">{buttonText}</Typography>
              <MoreIcon fontSize="small" color="secondary" style={{ marginLeft: 4, marginTop: 4 }} />
            </div>
          </Button>
          <Menu {...bindMenu(popupState)}>{getProbeItems(popupState)}</Menu>
        </>
      )}
    </PopupState>
  );
};

ProbePicker.propTypes = {
  defaultBucketSettings: PropTypes.object,
  setSelectedDeviceOverride: PropTypes.func,
  selectedDeviceOverride: PropTypes.object,
};

ProbePicker.defaultProps = {
  defaultBucketSettings: { period: undefined, unit: undefined, include_today: undefined },
  setSelectedDeviceOverride: undefined,
  selectedDeviceOverride: undefined,
};

export default ProbePicker;
